let lastPlayedAt = 0;

export const playNotificationSound = () => {
  if (typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastPlayedAt < 600) return;
  lastPlayedAt = now;

  const AudioContextClass =
    (window as any).AudioContext || (window as any).webkitAudioContext;
  if (!AudioContextClass) return;

  try {
    const audioContext = new AudioContextClass();
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(880, audioContext.currentTime);
    gain.gain.setValueAtTime(0.0001, audioContext.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.15, audioContext.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + 0.22);

    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.24);
    oscillator.onended = () => audioContext.close();
  } catch (error) {
    // Browsers can block sound before user interaction; silently ignore.
  }
};
